// Scotch (Bloodsomes / alternate-shot) — ported verbatim from
// GolfGamesScorecard's calcScotch (utils/scoring.ts). 2 teams of 2, match play
// on the team's per-hole total (partners' entries summed).
export function calcScotch(team1, team2) {
  const teamTotal = (team, h) => {
    const ss = team.map((p) => p.scores[h])
    if (ss.every((s) => s === null || s === undefined)) return null
    return ss.reduce((s, v) => s + (v ?? 0), 0)
  }
  let t1Up = 0
  const results = []
  for (let h = 0; h < 18; h++) {
    const a = teamTotal(team1, h)
    const b = teamTotal(team2, h)
    if (a == null || b == null) { results.push(null); continue }
    if (a < b) { t1Up++; results.push('t1') }
    else if (b < a) { t1Up--; results.push('t2') }
    else results.push('halved')
  }
  return { t1Up, results, winner: t1Up > 0 ? 'Team 1' : t1Up < 0 ? 'Team 2' : 'All Square' }
}
